import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { JsonEditorOptions } from "ang-jsoneditor";
import { diffString, diff } from "json-diff";

@Component({
  selector: "app-json-configuration-management",
  template: require('./json-configuration-management.component.html'),
  styles: [require('./json-configuration-management.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JsonConfigurationManagementComponent implements OnInit {
  latestConfig: any;
  updateLocalChanges = false;

  @Input() schema: any;
  @Input() configurations: any[];
  @Input() configCategories: any[];
  @Input() activeConfig: any;

  @Output() onSetActiveConfig = new EventEmitter<any>();
  @Output() onViewConfig = new EventEmitter<any>();
  @Output() dataChanged = new EventEmitter<any>();

  compareCandidateVersions: any[];
  comparedVersion: any;

  public editorOptions: JsonEditorOptions;

  constructor() {
    this.editorOptions = {
      ...new JsonEditorOptions(),
      modes: ["code"],
      mode: "code",
      schema: this.schema
    };
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.comparedVersion = null;
    if (this.activeConfig) {
      this._setCompareCandidateVersions();
    } else {
      this.latestConfig = undefined;
    }
  }

  jsonDataChanged = (data: any) => {
    this.updateLocalChanges = false;
    this.latestConfig = undefined;
    setTimeout(() => {
      this.latestConfig =
        data && diff(this.activeConfig, data)
          ? {
              ...data
            }
          : undefined;
      this.dataChanged.emit({ ...this.latestConfig });
      if (this.latestConfig !== undefined) {
        this.updateLocalChanges = true;
      }
    }, 0);
  };

  setActive = (selectedConfig: any) => {
    this.jsonDataChanged(undefined);
    const configuration = this.configurations.find(
      config => config.version == selectedConfig.version
    );
    if (configuration) {
      configuration.activatedOn = new Date().getTime();
      this.onSetActiveConfig.emit(configuration);
    }
  };

  viewConfig = (configuration: any) => {
    this.jsonDataChanged(undefined);
    this.onViewConfig.emit(configuration);
  };

  cancelCompare = () => (this.comparedVersion = null);

  _setCompareCandidateVersions = () => {
    this.compareCandidateVersions =
      this.configurations &&
      this.configurations
        .filter(
          configuration => configuration.version !== this.activeConfig.version
        )
        .sort((c1, c2) => (c1.version - c2.version > 0 ? 1 : -1));
  };
}
